








import { Vue, Component } from 'vue-property-decorator';
import Banner from '@/components/Banner.vue';
import BottomTabbar from '@/components/BottomTabbar.vue';
import { OPTHINES } from './config';
import { getBaseInfo } from './api';

@Component({
  components: {
    Banner,
    BottomTabbar,
  },
})
export default class Home extends Vue {
  option = OPTHINES;
  data: any = {};

  created() {
    this.getBaseInfo();
  }

  async getBaseInfo() {
    console.log('afa');

    const res: any = await getBaseInfo();
    this.data = res.data;
    this.$addPv(res.data.activityId);
    this.$appShareInfo({
      title: '发现重庆之美：2020重庆市最美环卫工人暨最美坡坎崖调查推选活动',
      url: window.location.href,
      subtitle: '发现重庆之美：2020重庆市最美环卫工人暨最美坡坎崖调查推选活动',
      classId: -1,
      id: -1,
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });

    this.$wxShareInfo({
      title: '发现重庆之美：2020重庆市最美环卫工人暨最美坡坎崖调查推选活动',
      subtitle: '发现重庆之美：2020重庆市最美环卫工人暨最美坡坎崖调查推选活动',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
}
